import { render, staticRenderFns } from "./documentation.vue?vue&type=template&id=0ce4a928&"
import script from "./documentation.vue?vue&type=script&lang=js&"
export * from "./documentation.vue?vue&type=script&lang=js&"
import style0 from "./documentation.vue?vue&type=style&index=0&id=0ce4a928&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports